import component from './categories.vue'

export default component
